export class asideNav {
	constructor( node ) {
		this.node = node;
		if ( ! this.node ) return;

		const responsiveBtn = this.node.querySelector( '.wp-block-navigation__responsive-container-open' );
		if ( responsiveBtn ) {
			const span = document.createElement( 'span' );
			span.textContent = 'In this Section';
			responsiveBtn.prepend( span );
		}

		this.node.querySelectorAll( '.wp-block-navigation__submenu-container' ).forEach( ( submenu ) => {
			const parentItem = submenu.closest( '.wp-block-navigation-item' );

			// Prevent submenu opening on hover/focus
			[
				'mouseenter',
				'mouseleave',
				'focusin',
				'focusout',
			].forEach( ( eventType ) => {
				parentItem.addEventListener(
					eventType,
					( e ) => {
						e.stopImmediatePropagation();
					},
					true
				);
			} );
		} );

		this.node.querySelectorAll( '.wp-block-navigation-item' ).forEach( ( parentItem ) => {
			const link = parentItem.querySelector( 'a' );
			const toggle = parentItem.querySelector( '.wp-block-navigation__submenu-icon, .wp-block-navigation-submenu__toggle' );
			const submenu = parentItem.querySelector( '.wp-block-navigation__submenu-container' );

			const toggleFix = ( e ) => {
				e.preventDefault();
				e.stopPropagation();
				//setTimeout added so that this function fires last after other core-nav functions are fired
				setTimeout( () => {
					const isOpen = parentItem.classList.contains( 'is-open' );
					if ( isOpen ) {
						parentItem.classList.remove( 'is-open' );
						toggle.setAttribute( 'aria-expanded', 'false' );
					} else {
						parentItem.classList.add( 'is-open' );
						toggle.setAttribute( 'aria-expanded', 'true' );
					}
				}, 10 );
			};

			// Label/Link click: toggle if href is # or empty
			if ( link && submenu ) {
				link.addEventListener( 'click', ( e ) => {
					const href = link.getAttribute( 'href' );
					if ( ! href || href === '#' ) {
						toggleFix( e );
					}
				} );
			}

			// Toggle button click
			toggle?.addEventListener( 'click', ( e ) => {
				toggleFix( e );
			} );
		} );

		// Improved recursive expansion for current page
		setTimeout( () => {
			this.node.querySelectorAll( '[aria-current="page"]' ).forEach( ( activeLink ) => {
				// Skip if inside quick links
				if ( activeLink.closest( '.quick-links' ) ) return;
				let parentItem = activeLink.closest( '.wp-block-navigation-item' );
				let topLevelItem = null;
				while ( parentItem ) {
					const submenu = parentItem.querySelector( '.wp-block-navigation__submenu-container' );
					const toggle = parentItem.querySelector( '.wp-block-navigation__submenu-icon, .wp-block-navigation-submenu__toggle' );
					if ( submenu && toggle ) {
						parentItem.classList.add( 'is-open' );
						toggle.setAttribute( 'aria-expanded', 'true' );
					}
					topLevelItem = parentItem; // Will end up as the highest ancestor
					parentItem = parentItem.parentElement.closest( '.wp-block-navigation-item' );
				}
				if ( topLevelItem ) {
					topLevelItem.classList.add( 'is-menu-active' );
				}
			} );
		}, 500 );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( 'nav.wp-block-navigation.is-style-aside' ).forEach( ( node ) => {
		new asideNav( node );
	} );
} );
